var map = {
	"./black/xiazailuxiang2.png": "wOVH",
	"./blue/xiazailuxiang2.png": "uWM+",
	"./white/xiazailuxiang2.png": "l5d4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wDnI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazailuxiang2\.png$
// module id = wDnI
// module chunks = 24